import { Alert, AlertTitle, Typography } from '@mui/material';
import { appendUidToUrl, buildEntryLink, buildRLink } from '../utils/domains';

interface LinkPreviewProps {
  domains: any[];
  domainId: string;
  uniqueId: string;
  title: string;
}

function LinkPreview({ domains, domainId, uniqueId, title }: LinkPreviewProps) {
  const getLink = (): string => {
    const domain = domains.find((domain) => domain._id === domainId);

    if (!domain) return '';

    const isEntry = domain.isEntry === true;

    if (isEntry) return buildEntryLink(domain.domainLink, uniqueId);

    const isOnlydrops = domain.domainName.includes('onlydrops');

    if (isOnlydrops) return appendUidToUrl(domain.domainLink, uniqueId);

    return buildRLink(domain.domainLink, uniqueId);
  };

  const link = getLink();

  if (!link) return null;

  return (
    <Alert severity="info">
      <AlertTitle>{title}</AlertTitle>
      <Typography variant="body2">{link}</Typography>
    </Alert>
  );
}

export default LinkPreview;
